import gql from 'graphql-tag';

export const CREATE_EXERCISE = gql`
  mutation CreateExercise($input: ExerciseInput!) {
    createExercise(input: $input) {
      _id
    }
  }
`;

export const UPDATE_EXERCISE = gql`
  mutation UpdateExercise($id: MOID!, $input: ExerciseUpdateInput!) {
    updateExercise(id: $id, input: $input) {
      _id
    }
  }
`;

export const REMOVE_QUESTION = gql`
  mutation RemoveQuestion($id: MOID!) {
    removeQuestion(id: $id)
  }
`;
